export function textFieldMask(value) {
  value = value.replaceAll(/[а-яА-Я]/giu, "").split("");

  return value;
}

export function slugFieldMask(value) {
  return value.replaceAll(/[^a-z\-0-9]/giu, "").split("");
}
